import React,{Component} from 'react';
import Select from"../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import 'moment/locale/tr';
import {Col, FormGroup, Input, Label, Row, UncontrolledTooltip} from 'reactstrap';
import {validateField} from "../../common/validation";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import DefaultModal from "../invoice/DefaultModal";
import {isValidExpenseNote} from "../../common/componentValidation";
import NumberFormat from 'react-number-format';
import {Decimal} from 'decimal.js';
import Alert from "react-s-alert";
import TotalList from "../voucher/component/TotalList";

const cETTN = {
	backgroundColor: "#ababab",
	paddingLeft: "5px",
	color: "#fefefe",
	borderRadius: "3px",
	marginBottom: "5px",
	fontSize: "13px",
	fontWeight: "bold",
	position: "relative"
};

class ExpenseNoteModal extends Component {

	constructor(props){
		super(props);
		this.state={error:{}, expenseNote:null};
		this.validateField 			= this.validateField.bind(this);
		this.onChangeExpenseNoteLine= this.onChangeExpenseNoteLine.bind(this);
		this.onChangeBasicInfo 	    = this.onChangeBasicInfo.bind(this);
		this.setExpenseNote 	    = this.setExpenseNote.bind(this);
		this.removeLine 	    	= this.removeLine.bind(this);
	}

	componentWillMount(){
		let self = this;
		let params = {
			url: `/expenseNote/getReturn`,
			method: "post",
			data:{
				recordId:(this.props.recordId || null),
				documentUuid:this.props.documentUuid
			}
		};
		request(params)
		.then(response => {
			let charges = response.data.charges;
			let expenseNote = deepCopyObject(response.data.expenseNote);
			let expenseNoteLines = deepCopyObject(expenseNote.expenseNoteLines);
			for (let i = 0; i < expenseNoteLines.length; i++) {
				let expenseNoteLineCharges = expenseNoteLines[i].expenseNoteLineCharges;
				expenseNoteLineCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);
			}
			expenseNote["expenseNoteLineCharges"] = expenseNoteLines;

			let addedCharges = [];
			if (expenseNoteLines.length > 0) {
				let firstCharges = expenseNoteLines[0].expenseNoteLineCharges;
				for (let i = 0; i < firstCharges.length; i++) {
					addedCharges.push(deepCopyObject(charges.find(function (charge) {
						return charge.code === firstCharges[i].taxCode.code;
					})));
				}
			}

			self.setState({
				initExpenseNote:deepCopyObject(response.data.expenseNote),
				expenseNote:expenseNote,
				unitCodes:response.data.unitCodes,
				charges:charges,
				addedCharges:addedCharges
			});
		})
		.catch(function (error) {
			showAxiosError(error);
		});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	setExpenseNote(e){
		e.preventDefault();
		let self = this;
		let expenseNote = deepCopyObject(this.state.expenseNote);
		let result = isValidExpenseNote(expenseNote);
		let error = result.error;
		let valid = result.valid;
		if(valid){
			let params = {
				url: `/expenseNote/save`,
				method: "post",
				data:expenseNote
			};
			self.setState({btnDisabled:true});
			request(params)
			.then(response => {
				Alert.closeAll();
				Alert.success('Gider Pusulası başarılı şekilde kaydedildi.', {
					position: 'top-right',
					effect: 'stackslide',
					timeout: 2000
				});
				self.props.toggleModal(false);
			})
			.catch(function (error) {
				showAxiosError(error);
			}).then(() => {
				self.setState({btnDisabled:false});
			});
		}else{
			Alert.error(result.errorMessage, {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 8000
			});
			self.setState({error});
		}
	}

	onChangeBasicInfo(e){
		let name  	= e.target.name;
		let value 	= e.target.value;
		let expenseNote = deepCopyObject(this.state.expenseNote);

		if(name === "issueDate" && !(typeof value === "string")){
			expenseNote[name]  = value.format("YYYY-MM-DD HH:mm:ss");
		}else{
			expenseNote[name] = value;
		}
		this.setState({expenseNote});
	}

	onChangeExpenseNoteLine(e,index){
		let expenseNote = deepCopyObject(this.state.expenseNote);
		let expenseNoteLines = deepCopyObject(expenseNote.expenseNoteLines);
		expenseNoteLines[index][e.name] = (e.name === "quantity" || e.name === "unitPrice") ? (new Decimal(e.value)).toNumber() : e.value;
		if (e.name !== "itemName" && e.name !== "unit") {
			expenseNoteLines[index] = this.calculate(expenseNoteLines[index]);
		}
		expenseNote["expenseNoteLines"] = expenseNoteLines;
		expenseNote = this.calculateTotal(expenseNote);
		this.setState({expenseNote});
	}

	calculate(expenseNoteLine) {
		let expenseNoteLineCharges = deepCopyObject(expenseNoteLine.expenseNoteLineCharges);
		expenseNoteLineCharges.sort((charge1, charge2) => charge1.taxCode.priority - charge2.taxCode.priority);
		let baseTaxableAmount = (new Decimal(expenseNoteLine.quantity).mul(new Decimal(expenseNoteLine.unitPrice)));

		let kdvTaxableAmount = (new Decimal(0)).add(baseTaxableAmount);
		for (let i = 0; i < expenseNoteLineCharges.length; i++) {
			let lineCharge = expenseNoteLineCharges[i];
			let priority = lineCharge.taxCode.priority;
			let nTaxableAmount = new Decimal(0.00);
			if (lineCharge.taxCode.calculatedBy === "UNIT") {
				expenseNoteLineCharges[i].taxableAmount = new Decimal(0).toNumber();
				if (expenseNoteLineCharges[i].calculateFrom === "amount") {
					if (!new Decimal(expenseNoteLine.quantity).isZero())
						expenseNoteLineCharges[i].perUnitAmount = (new Decimal(expenseNoteLineCharges[i].amount)).div(new Decimal(expenseNoteLine.quantity)).toNumber();
				} else {
					expenseNoteLineCharges[i].amount = new Decimal((new Decimal(expenseNoteLineCharges[i].perUnitAmount)).mul(new Decimal(expenseNoteLine.quantity)).toFixed(2)).toNumber();
				}
			} else {
				for (let j = 0; j < i; j++) {
					let iPriority = expenseNoteLineCharges[j].taxCode.priority;
					let affectTaxableAmount = expenseNoteLineCharges[j].taxCode.affectTaxableAmount;
					if (iPriority < priority && affectTaxableAmount === 1) {
						nTaxableAmount = nTaxableAmount.add(new Decimal(expenseNoteLineCharges[j].amount).mul(new Decimal(expenseNoteLineCharges[j].taxCode.direction)));
						if (expenseNoteLineCharges[j].taxCode.isAffectKdv === 1)
							kdvTaxableAmount = kdvTaxableAmount.add(new Decimal(expenseNoteLineCharges[j].amount).mul(new Decimal(expenseNoteLineCharges[j].taxCode.direction)));
					}
				}

				//KDV matrahı
				if (expenseNoteLineCharges[i].taxCode.code === "0015") {
					expenseNoteLineCharges[i].taxableAmount = kdvTaxableAmount.toNumber();
				} else {
					expenseNoteLineCharges[i].taxableAmount = baseTaxableAmount.plus(nTaxableAmount).toNumber();
				}

				if (expenseNoteLineCharges[i].taxCode.calculateFrom === "amount") {
					if (!new Decimal(expenseNoteLineCharges[i].taxableAmount).isZero())
						expenseNoteLineCharges[i].percentage = (new Decimal(expenseNoteLineCharges[i].amount)).div(new Decimal(expenseNoteLineCharges[i].taxableAmount)).mul(new Decimal(100)).toNumber();
				} else {
					expenseNoteLineCharges[i].amount = new Decimal((new Decimal(expenseNoteLineCharges[i].taxableAmount)).mul(new Decimal(expenseNoteLineCharges[i].percentage).div(new Decimal(100))).toFixed(2)).toNumber();
				}
			}
		}

		let tCharges = deepCopyObject(expenseNoteLine.expenseNoteLineCharges);
		for (let i = 0; i < expenseNoteLineCharges.length; i++) {
			for (let j = 0; j < tCharges.length; j++) {
				if (expenseNoteLineCharges[i].taxCode.code === tCharges[j].taxCode.code) {
					tCharges[j] = deepCopyObject(expenseNoteLineCharges[i]);
					break;
				}
			}
		}
		expenseNoteLine.lineExtensionAmount = new Decimal(baseTaxableAmount.toFixed(2)).toNumber();
		expenseNoteLine.expenseNoteLineCharges = deepCopyObject(tCharges);
		return expenseNoteLine;
	}

	removeLine(index){
		let expenseNote = deepCopyObject(this.state.expenseNote);
		let expenseNoteLines = deepCopyObject(expenseNote.expenseNoteLines);
		if (expenseNoteLines.length === 1) {
			Alert.error("Belge en az bir satır içermelidir.", {
				position: 'top-right',
				effect: 'stackslide',
				timeout:2000
			});
		} else {
			expenseNoteLines.splice(index, 1);
			expenseNote["expenseNoteLines"] = expenseNoteLines;
			expenseNote = this.calculateTotal(expenseNote);
			this.setState({expenseNote});
		}
	}

	calculateTotal(tData) {
		let data = deepCopyObject(tData);
		let expenseNoteLines = data.expenseNoteLines;
		let lineExtensionTotalAmount = new Decimal(0.00);
		let lineChargeTotalAmount = new Decimal(0.00);
		let allowanceTotalAmount = new Decimal(0.00);
		let toBeAddedTotalChargeAmount = new Decimal(0.00);
		for (let i = 0; i < expenseNoteLines.length; i++) {
			let expenseNoteLine = expenseNoteLines[i];
			let expenseNoteLineCharges = expenseNoteLine.expenseNoteLineCharges;
			lineExtensionTotalAmount = lineExtensionTotalAmount.add(new Decimal(expenseNoteLine.lineExtensionAmount));
			for (let j = 0; j < expenseNoteLineCharges.length; j++) {
				let expenseNoteLineCharge = expenseNoteLineCharges[j];
				lineChargeTotalAmount = lineChargeTotalAmount.add((new Decimal(expenseNoteLineCharge.amount)).mul(expenseNoteLineCharge.taxCode.direction));
				if (expenseNoteLineCharge.taxCode.code === "0000")
					allowanceTotalAmount = allowanceTotalAmount.add(new Decimal(expenseNoteLineCharge.amount));
				else {
					if (expenseNoteLineCharge.taxCode.direction === 1) {
						toBeAddedTotalChargeAmount = toBeAddedTotalChargeAmount.add(new Decimal(expenseNoteLineCharge.amount));
					} else {

					}
				}
			}
		}
		data.payableAmount = new Decimal(lineExtensionTotalAmount.add(lineChargeTotalAmount).toFixed(2)).toNumber();
		data.lineExtensionAmount  = new Decimal(lineExtensionTotalAmount.toFixed(2)).toNumber();
		data.allowanceTotalAmount = new Decimal(allowanceTotalAmount.toFixed(2)).toNumber();
		data.taxInclusiveAmount   = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).add(toBeAddedTotalChargeAmount).toFixed(2)).toNumber();
		data.taxExclusiveAmount   = new Decimal(lineExtensionTotalAmount.sub(allowanceTotalAmount).toFixed(2)).toNumber();
		return data;
	}

	render(){
		return(
			<DefaultModal
				isOpen={this.props.modal}
				disabled={this.state.btnDisabled}
				title="Gider Pusulası"
				size="lg"
				modalBodyStyle={{padding: "0", minHeight: "500px"}}
				confirmBtnText="Kaydet"
				cancelBtnText="İptal"
				onConfirm={(e)=>this.setExpenseNote(e)}
				onCancel={(e)=>this.props.toggleModal(false)}>
					<Col sm="12">
						<Col style={cETTN}>
							<Row className="col-sm-7">
								ETTN: {this.state.expenseNote ? this.state.expenseNote.documentUuid : "Yükleniyor..."}
							</Row>
						</Col>
						<Col sm="6" className="row" style={{fontWeight: "bold", paddingBottom: "5px"}}>
							İade Zamanı:
							{this.state.expenseNote &&
								<Datetime locale="tr"
										  input={true}
										  inputProps={{id: 'issueDate'}}
										  closeOnSelect={false}
										  closeOnTab={false}
										  value={moment(this.state.expenseNote.issueDate, "YYYY-MM-DD HH:mm:ss", true).isValid() || moment(this.state.expenseNote.issueDate, "YYYY-MM-DD HH:mm:ss", true).isValid() ?
											  moment(this.state.expenseNote.issueDate).format("DD-MM-YYYY HH:mm:ss") :
											  this.state.expenseNote.issueDate}
										  dateFormat="DD-MM-YYYY"
										  timeFormat="HH:mm:ss"
										  isValidDate={function (now, selected) {
											  return true;
										  }}
										  onChange={(e) => this.onChangeBasicInfo({target: {name: "issueDate", value: e}})}/>
							}
							{!this.state.expenseNote && "Yükleniyor..."}
							{this.validateMessage('issueDate') !== "" &&
								<UncontrolledTooltip placement="right" target="issueDate" delay={0}>
									{this.validateMessage("issueDate")}
								</UncontrolledTooltip>
							}
						</Col>
						<Col sm="12">
							<Row className="baseDashboard">
								<Col sm="12" className="row">
									<Col sm="6">
										<Col className="card-header">
											<h4 className="card-title">Gönderici Bilgileri</h4>
										</Col>
										<div>
											<Col className="card-body">
												{this.state.expenseNote &&
													<Row>
														<Col sm="12">
															<FormGroup row className={this.validateClass('sourceAddress')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>Adres:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   name="sourceAddress"
																		   id="sourceAddress"
																		   value={this.state.expenseNote.sourceAddress || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('sourceAddress') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="sourceAddress"
																						 delay={0}>
																		{this.validateMessage("sourceAddress")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
														<Col sm="12">
															<FormGroup row className={this.validateClass('sourceId')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>VKN/TCKN:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   name="sourceId"
																		   disabled={true}
																		   id="sourceId"
																		   value={this.state.expenseNote.sourceId || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('sourceId') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="sourceId"
																						 delay={0}>
																		{this.validateMessage("sourceId")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
														<Col sm="12">
															<FormGroup row className={this.validateClass('sourceTitle')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>Unvan:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   name="sourceTitle"
																		   disabled={true}
																		   id="sourceTitle"
																		   value={this.state.expenseNote.sourceTitle || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('sourceTitle') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="sourceTitle"
																						 delay={0}>
																		{this.validateMessage("sourceTitle")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
													</Row>
												}
												{!this.state.expenseNote && "Yükleniyor..."}
											</Col>
										</div>
									</Col>
									<hr style={{marginLeft: '-6px'}}></hr>
									<Col sm="6">
										<Col className="card-header">
											<h4 className="card-title">Alıcı Bilgileri</h4>
										</Col>
										<div>
											<Col className="card-body">
												{this.state.expenseNote &&
													<Row>
														<Col sm="12">
															<FormGroup row className={this.validateClass('destinationAddress')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>Adres:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   name="destinationAddress"
																		   id="destinationAddress"
																		   value={this.state.expenseNote.destinationAddress || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('destinationAddress') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="destinationAddress"
																						 delay={0}>
																		{this.validateMessage("destinationAddress")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
														<Col sm="12">
															<FormGroup row className={this.validateClass('destinationId')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>VKN/TCKN:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   disabled={true}
																		   name="destinationId"
																		   id="destinationId"
																		   value={this.state.expenseNote.destinationId || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('destinationId') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="destinationId"
																						 delay={0}>
																		{this.validateMessage("destinationId")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
														<Col sm="12">
															<FormGroup row className={this.validateClass('destinationTitle')}>
																<Label sm={3} style={{whiteSpace: "nowrap"}}>Unvan:*</Label>
																<Col sm={9}>
																	<Input type="text"
																		   disabled={true}
																		   name="destinationTitle"
																		   id="destinationTitle"
																		   value={this.state.expenseNote.destinationTitle || ""}
																		   onChange={this.onChangeBasicInfo}/>
																	{this.validateMessage('destinationTitle') !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target="destinationTitle"
																						 delay={0}>
																		{this.validateMessage("destinationTitle")}
																	</UncontrolledTooltip>}
																</Col>
															</FormGroup>
														</Col>
													</Row>
												}
												{!this.state.expenseNote && "Yükleniyor..."}
											</Col>
										</div>
									</Col>
								</Col>
							</Row>
						</Col>
						<div className="baseDashboard" style={{marginTop: '5px'}}>
							<Col sm="12">
								<Col className="card-header">
									<h4 className="card-title">Ürün/Hizmet Bilgileri</h4>
								</Col>
								<div>
									<div className="card-body">
										{this.state.expenseNote &&
											<Row>
												<Col sm="12" style={{paddingRight: '5px'}}>
													<table className="" style={{textAlign: 'center', paddingBottom: "15px"}}>
														<thead>
														<tr style={{backgroundColor: '#ebedf0'}}>
															<th width="5%">#</th>
															<th width="20%">Ürün/Hizmet</th>
															<th width="10%">Miktar</th>
															<th width="10%">Birim</th>
															<th width="10%">Birim Fiyat</th>
															{
																this.state.addedCharges.map((addedCharge, index) =>
																	<th width="20%" key={index}>
																		{addedCharge.shortName}
																	</th>
																)
															}
															<th width="5%">İşlemler</th>
														</tr>
														</thead>
														<tbody>
														{this.state.expenseNote.expenseNoteLines.map((line, index) =>
															<tr key={index}>
																<td>{index + 1}</td>
																<td>
																	<input
																		id={'itemName_' + index}
																		type="text"
																		data-vlength="1,255"
																		disabled={true}
																		className="form-control"
																		onBlur={this.validateField}
																		value={line.itemName}
																		onChange={(e) => this.onChangeExpenseNoteLine({
																			value: e.target.value,
																			name: "itemName"
																		}, index)}/>
																	{this.validateMessage('itemName_' + index) !== "" &&
																	<UncontrolledTooltip placement="right"
																						 target={'itemName_' + index}
																						 delay={0}>
																		{this.validateMessage('itemName_' + index)}
																	</UncontrolledTooltip>}
																</td>
																<td style={{borderColor: "#18ce0f"}}>
																	<NumberFormat id={'quantity_' + index}
																				  value={line.quantity}
																				  allowNegative={false}
																				  isNumericString={true}
																				  allowEmptyFormatting={false}
																				  decimalScale={2}
																				  thousandSeparator={'.'}
																				  decimalSeparator={','}
																				  displayType="input"
																				  isAllowed={values => {
																					  return (values.value === "" ? false : true);
																				  }}
																				  placeholder=""
																				  renderText={value => {
																					  value.replace(/\./g, ',')
																				  }}
																				  onValueChange={(e) => this.onChangeExpenseNoteLine({
																					  value: e.value,
																					  name: "quantity"
																				  }, index)}
																				  className="form-control"/>
																</td>
																<td>
																	<Select
																		id={'unit_' + index}
																		disabled={true}
																		placeholder={line.unit}
																		value={line.unit}
																		clearable={false}
																		style={{width: "100%"}}
																		noResultsText="Sonuç yok"
																		onChange={(e) => e && this.onChangeExpenseNoteLine({
																			value: e.value,
																			name: "unit"
																		}, index)}
																		options={this.state.unitCodes.map(unitCode => ({
																			value: unitCode.shortCode,
																			label: unitCode.longCode
																		}))}
																	/>
																</td>
																<td>
																	<NumberFormat id={'unitPrice_' + index}
																				  value={line.unitPrice}
																				  allowNegative={false}
																				  disabled={true}
																				  isNumericString={true}
																				  allowEmptyFormatting={false}
																				  decimalScale={2}
																				  thousandSeparator={'.'}
																				  decimalSeparator={','}
																				  displayType="input"
																				  isAllowed={values => {
																					  return (values.value === "" ? false : true);
																				  }}
																				  placeholder=""
																				  renderText={value => {
																					  value.replace(/\./g, ',')
																				  }}
																				  onValueChange={(e) => this.onChangeExpenseNoteLine({
																					  value: e.value,
																					  name: "unitPrice"
																				  }, index)}
																				  className="form-control"/>
																</td>
																{
																	line.expenseNoteLineCharges.map((charge, j) =>
																		<td key={j}>
																			<div className="row" style={{}}>
																				<NumberFormat
																					id={charge.taxCode.code + '_percentage_' + j + '_' + index}
																					value={(charge.taxCode.calculatedBy === "AMOUNT" ? charge.percentage : charge.perUnitAmount)}
																					allowNegative={false}
																					suffix={charge.taxCode.calculatedBy === "AMOUNT" ? '%' : ""}
																					isNumericString={true}
																					disabled={true}
																					decimalScale={2}
																					thousandSeparator={'.'}
																					decimalSeparator={','}
																					displayType="input"
																					isAllowed={values => {
																						return (values.value === "" ? false : true);
																					}}
																					renderText={value => {
																						value.replace(/\./g, ',')
																					}}
																					onValueChange={(e) => ""}
																					className="form-control text2"/>
																				<NumberFormat
																					id={charge.taxCode.code + '_amount_' + j + '_' + index}
																					value={charge.amount}
																					allowNegative={false}
																					isNumericString={true}
																					disabled={true}
																					suffix={""}
																					decimalScale={2}
																					thousandSeparator={'.'}
																					decimalSeparator={','}
																					displayType="input"
																					isAllowed={values => {
																						return (values.value === "" ? false : true);
																					}}
																					renderText={value => {
																						value.replace(/\./g, ',')
																					}}
																					onValueChange={(e) => ""}
																					className="form-control text"/>
																			</div>
																		</td>
																	)
																}
																<td>
																	<button type="button" className="Btn temizle"
																			disabled={!(this.state.expenseNote.expenseNoteLines.length > 1)}
																			style={{margin: "0", background: '#FFCCCC'}}
																			onClick={() => this.removeLine(index)}>
																	</button>
																</td>
															</tr>
														)}
														</tbody>
													</table>
												</Col>
											</Row>
										}
										{!this.state.expenseNote && "Yükleniyor..."}
									</div>
								</div>
							</Col>
						</div>
						<div className="baseDashboard" style={{marginTop: '5px'}}>
							<Col sm="12">
								<Col className="card-header">
									<h4 className="card-title">Pusula Toplamları</h4>
								</Col>
								<Col sm="12">
									<div className="card-body">
										{this.state.expenseNote &&
											<TotalList suffix=""
													   lines={this.state.expenseNote.expenseNoteLines}
													   chargesName={"expenseNoteLineCharges"}
													   lineExtensionAmount={this.state.expenseNote.lineExtensionAmount}
													   taxExclusiveAmount={this.state.expenseNote.taxExclusiveAmount}
													   taxInclusiveAmount={this.state.expenseNote.taxInclusiveAmount}
													   showATA={true}
													   payableAmount={this.state.expenseNote.payableAmount}/>
										}
										{!this.state.expenseNote && "Yükleniyor..."}
									</div>
								</Col>
							</Col>
						</div>
					</Col>
			</DefaultModal>
		);
	}
}

export default ExpenseNoteModal;

